const TEPKINLY_LEGAL_NOTICE_KEY = 'tepkinlyShowLegalNotice';

function showTepkinlyLegalNotice() {
	const legalNotice =
		typeof tepkinlyData !== 'undefined' && tepkinlyData.legalNotice
			? tepkinlyData.legalNotice
			: '';
	const confirmLabel =
		typeof tepkinlyData !== 'undefined' && tepkinlyData.legalConfirm
			? tepkinlyData.legalConfirm
			: 'Cerrar';

	return Swal.fire({
		html: legalNotice,
		confirmButtonText: confirmLabel,
		confirmButtonColor: '#784fa7',
		customClass: {
			popup: 'ab-tepkinly-legal-notice',
			confirmButton: 'ab-tepkinly-legal-notice__confirm',
		},
	});
}

window.tepkinlyAccess = {
	_form: undefined,

	init: function () {
		this._form = document.querySelector('form[name="tepkinlyAccess"]');

		if (!this._form) {
			return;
		}

		this._form.addEventListener('submit', (event) => {
			event.preventDefault();
			tepkinlyAccess._handleSubmit(event, this._form);
		});
	},

	_handleSubmit: function (event, form) {
		if (!wpData.GRV3) {
			Swal.fire({
				title: 'No se ha podido cargar la verificación de seguridad.',
				text: 'Falta la clave de Turnstile en la configuración del sitio.',
				icon: 'error',
				confirmButtonColor: '#6888ca',
			});
			return;
		}

		if (typeof turnstile === 'undefined') {
			Swal.fire({
				title: 'No se ha podido cargar la verificación de seguridad.',
				text: 'Recarga la página e inténtalo de nuevo.',
				icon: 'error',
				confirmButtonColor: '#6888ca',
			});
			return;
		}

		const turnstileContainer = form.querySelector('.turnstile-container');
		turnstileContainer.innerHTML = '';
		turnstile.render(turnstileContainer, {
			sitekey: wpData.GRV3,
			callback: (token) => {
				document.getElementById('cf-turnstile-response').value = token;
				tepkinlyAccess._processForm(event, form);
			},
			'error-callback': () => {
				Swal.fire({
					title: 'No se ha podido cargar la verificación de seguridad.',
					text: 'Recarga la página e inténtalo de nuevo.',
					icon: 'error',
					confirmButtonColor: '#6888ca',
				});
			},
		});
	},

	_processForm: function (event, form) {
		const formStatus = validateAndGetFormParams(form);

		if (formStatus.errors && Object.keys(formStatus.errors).length > 0) {
			Swal.fire({
				title: 'Hemos encontrado errores en el formulario',
				html: setSweetAlertErrorsHTML(formStatus.errors),
				icon: 'error',
				confirmButtonColor: '#6888ca',
			}).then(() => {
				if (typeof turnstile !== 'undefined') {
					turnstile.reset();
				}
			});
			return;
		}

		formStatus.params['cf-turnstile-response'] = document.getElementById('cf-turnstile-response').value;
		tepkinlyAccess._sendRequest(formStatus.params);
	},

	_sendRequest: function (params) {
		const data = {
			endpoint: '/access/tepkinly',
			params: params,
			logged: false,
			errorsControl: true,
		};

		postAPICall(data)
			.then((res) => {
				if (res && res.success && res.redirect) {
					sessionStorage.setItem(TEPKINLY_LEGAL_NOTICE_KEY, '1');
					window.location.href = res.redirect;
					return;
				}

				Swal.fire({
					title: 'Se ha producido un error, por favor inténtalo de nuevo más tarde.',
					icon: 'error',
					confirmButtonColor: '#784fa7',
				});
			})
			.catch((err) => {
				let title = 'Se ha producido un error, por favor inténtalo de nuevo más tarde.';

				if (err && err.message) {
					title = err.message;
				} else if (err && err.data && err.data.message) {
					title = err.data.message;
				}

				Swal.fire({
					title: title,
					icon: 'error',
					confirmButtonColor: '#6888ca',
				}).then(() => {
					if (typeof turnstile !== 'undefined') {
						turnstile.reset();
					}
				});
			});
	},
};

function dismissTepkinlyLegalNotice(fromServer) {
	if (!fromServer) {
		return;
	}

	const dismissUrl =
		typeof tepkinlyData !== 'undefined' && tepkinlyData.dismissLegalNoticeUrl
			? tepkinlyData.dismissLegalNoticeUrl
			: '';

	if (!dismissUrl) {
		return;
	}

	fetch(dismissUrl, {
		method: 'POST',
		credentials: 'same-origin',
	});
}

window.tepkinlyHub = {
	_shown: false,

	init: function () {
		if (this._shown) {
			return;
		}

		const fromServer = typeof tepkinlyData !== 'undefined' && tepkinlyData.showLegalNotice;
		const fromStorage = sessionStorage.getItem(TEPKINLY_LEGAL_NOTICE_KEY) === '1';

		if (!fromServer && !fromStorage) {
			return;
		}

		if (typeof Swal === 'undefined') {
			return;
		}

		this._shown = true;
		sessionStorage.removeItem(TEPKINLY_LEGAL_NOTICE_KEY);
		showTepkinlyLegalNotice().then(() => {
			dismissTepkinlyLegalNotice(fromServer);
		});
	},
};

(function initTepkinlyHubPage() {
	function run() {
		if (!document.querySelector('.ab-tepkinly-hub')) {
			return;
		}

		tepkinlyHub.init();
	}

	if (document.readyState === 'complete') {
		run();
	} else {
		window.addEventListener('load', run);
	}
})();
